import { ChangeDetectionStrategy, Component, Input, OnDestroy, inject } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { ResponsiveService } from '../responsive.service';
import { LayoutService } from '../layout/layout.service';
import { LoadingComponent } from '../loading/loading.component';
import { CardWrapperComponent } from './card-wrapper/card-wrapper.component';

@Component({
  selector: 'app-balsa-card',
  templateUrl: './balsa-card.component.html',
  styleUrls: ['./balsa-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    L10nTranslatePipe,
    LoadingComponent,
    CardWrapperComponent,
  ],
})
export class BalsaCardComponent implements OnDestroy {
  locale = inject<L10nLocale>(L10N_LOCALE);
  private readonly responsiveService = inject(ResponsiveService);
  private readonly layoutService = inject(LayoutService);

  @Input() title: string;
  @Input() titleIcon: string;
  @Input() subtitle: string;
  @Input() loading: boolean;
  @Input() circleLoading: boolean;
  @Input() cardMargin = '1rem';
  @Input() headerMargin = '0';
  @Input() hasDivider = true;
  @Input() cardShadow = true;
  @Input() useCalculatedMaxHeight = false;
  @Input() minHeight = '0';
  @Input() useMarginBottom = true;
  @Input() additionalHeightOffset = '0px';

  /** Centers the card in the view in a responsive manner */
  @Input() centered = false;
  destroy = new Subject<void>();
  responsiveClass: Observable<string> = this.responsiveService.subject.pipe(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    map((state) => {
      if (state.isLargeIsh && state.isWeb) return 'large';
      return 'small';
    }),
    takeUntil(this.destroy),
  );

  get cardMaxHeightCalculation() {
    if (!this.useCalculatedMaxHeight) {
      return '100%';
    }

    let extraCalculation = '';
    if (this.cardMargin && this.cardMargin !== '0') {
      extraCalculation = ` - ${this.cardMargin}`;
    }

    return 'calc(100vh - ' + this.headerHeight + ' - 350px' + extraCalculation + ' - ' + this.additionalHeightOffset + ')';
  }

  get headerHeight() {
    return this.layoutService.layoutHeightOffsetTop + 'px';
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
